import { Container, Button, breakpoints } from "@brightagency/headstart-common";
import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "../../../utils/colors";
import { FeedbackModal } from "../FeedbackModal";

interface Props {
    reviewedDate: string;
}

const Outer = styled.div`
    background-color: ${colors.white};
`;

const Inner = styled.div`
    padding: 40px 0 60px;
    text-align: center;
    display: flex;
    align-items: center;
    gap: 24px;
    flex-direction: column;

    ${breakpoints.medium} {
        flex-direction: row;
    }
`;

const Title = styled.p`
    margin: 0;
    font-size: 16px;
    width: 100%;
    flex-shrink: 0;

    ${breakpoints.medium} {
        width: auto;
    }
`;

const Buttons = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-shrink: 0;
    width: 300px;

    button {
        width: 100%;
        max-width: 250px;
    }
`;

const Spacer = styled.div`
    width: 100%;
    display: none;

    ${breakpoints.medium} {
        display: block;
    }
`;

const Reviewed = styled.p`
    margin: 8px 0 0;
    font-size: 14px;
    width: 100%;
    flex-shrink: 0;

    ${breakpoints.medium} {
        width: auto;
        margin-left: 0;
    }
`;

export const PageFeedback: React.FC<Props> = props => {
    const [clickedYes, setClickedYes] = React.useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const handleYes = () => {
        setClickedYes(true);
    };

    const handleNo = () => {
        setClickedYes(false);
        setIsOpen(true);
    };

    return (
        <Outer>
            <Container>
                <Inner>
                    <Title>Was this page helpful?</Title>
                    <Buttons>
                        <Button
                            maxWidth={150}
                            onClick={handleYes}
                            appearance="subtle"
                            style={{
                                backgroundColor: clickedYes ? colors.brandMid : undefined,
                                color: clickedYes ? colors.white : undefined,
                            }}
                        >
                            Yes
                        </Button>
                        <Button onClick={handleNo} appearance="subtle">
                            No
                        </Button>
                    </Buttons>
                </Inner>
            </Container>
            <FeedbackModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </Outer>
    );
};
